import 'promise-polyfill/src/polyfill'
import 'whatwg-fetch'
import {isStorageAvailable} from './storage'

const COOKIE_SECONDS = 31536000
const DATA_KEY = 'erpvid'

const addErpvid = (erpvid, pat) => {
  const _links = document.getElementsByTagName('a')
  let links = []

  if(pat) {
    let re = new RegExp(pat)

    for(let i = 0; i < _links.length; i++) {
      const link = _links[i]
      if(re.test(link.getAttribute('href'))) {
        links.push(link)
      }
    }
  }
  else {
    for(let i = 0; i < _links.length; i++) {
      const link = _links[i]
      links.push(link)
    }
  }

  for (let i = 0; i < links.length; i++) {
    try {
      const url = new URL(links[i].href)
      url.searchParams.append(DATA_KEY, erpvid)

      links[i].href = url.href
    }
    catch(err) {
      continue
    }
  }
}

const checkStatus = response => {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    var error = new Error(response.statusText)
    error.response = response
    throw error
  }
}

const getErpvid = refreshKey => {
  let storage = refreshKey ? 'localStorage' : 'sessionStorage'

  if(isStorageAvailable(storage)) {
    return window[storage].getItem(DATA_KEY)
  }
  else {
    const c = document.cookie.split('; ').find(row => row.startsWith(DATA_KEY))
    if(!c) {
      return null
    }
    return c.split('=')[1]
  }
}

const saveErpvid = (erpvid, refreshKey) => {
  let storage = 'sessionStorage'
  let cookieSuffix = ''

  if(refreshKey) {
    storage = 'localStorage'
    cookieSuffix = `; Path=/; Max-Age=${COOKIE_SECONDS};`
  }

  if(isStorageAvailable(storage)) {
    window[storage].setItem(DATA_KEY, erpvid)
  }
  document.cookie = `erpvid=${erpvid}${cookieSuffix}`
}

(() => {
  const [requestTypeId, pat, refreshKey] = window.__ERPV__
  if(!requestTypeId) {
    return
  }

  const ep = new URL(`${process.env.API_ENDPOINT_PAGEVIEWS}${requestTypeId}`)

  // 大事な順に
  ep.searchParams.append('url', location.href)

  const ref = document.referer
  if(ref) {
    ep.searchParams.append('referer', ref)  
  }

  ep.searchParams.append('cookie', document.cookie)

  let erpvid = (refreshKey && location.search.indexOf(refreshKey) !== -1) ? null : getErpvid(refreshKey)
  if(erpvid) {
    return addErpvid(erpvid, pat)
  }

  fetch(ep.href)
    .then(checkStatus)
    .then(r => r.json())
    .then(data => {
      addErpvid(data.erpvid, pat)
      saveErpvid(data.erpvid, refreshKey)
    })
    .catch(error => {
      console.log('request failed', error)
    })
})()
